










































































import { Component, Vue } from "vue-property-decorator";
import headerTitle from "@/components/headerTitle.vue";
import { columns } from "./config/anomaly";
import { apiSpeedUpextractList, apiSpeedUpCheck } from "./service";
import anomalyModal from "./anomalyModal.vue";

@Component({
  components: { headerTitle, anomalyModal },
})
export default class Home extends Vue {
  public moneyList = [
    {
      id: 1,
      name: "全部",
    },
    {
      id: 2,
      name: "支付宝",
    },
    {
      id: 3,
      name: "盒币",
    },
  ];
  public loading = false;
  public data: any = {};
  public pageSize = {
    page: 1,
    pagenum: 10,
  };
  public form = {
    account: "",
    uid: "",
    extract_type: 1,
    type: 2,
  };
  public columns = columns;
  public addMoney(index) {
    this.pageSize.page = 1;
    this.form.extract_type = index;
    this.init();
  }
  public getInit() {
    this.pageSize.page = 1;
    this.init();
  }
  public mounted() {
    this.init();
  }
  public async init() {
    this.loading = true;
    const res = await apiSpeedUpextractList({
      ...this.form,
      ...this.pageSize,
      extract_type:
        this.form.extract_type == 1 ? "" : this.form.extract_type == 2 ? 1 : 2,
    });
    if (res.code == 0) {
      this.data = res.data.list;
    }
    this.loading = false;
  }
  public change(i) {
    this.pageSize.page = i;
    this.init();
  }
  public turnDown(uid, status) {
    if (status) {
      this.$Modal.confirm({
        title: "确定要通过？",
        onOk: () => {
          this.submit(uid);
        },
      });
    } else {
      const $anomalyModal: any = this.$refs.anomalyModal;
      $anomalyModal.show(uid);
    }
  }
  public async submit(uid, val?) {
    const res = await apiSpeedUpCheck({
      id_arr: [uid],
      type: val ? 2 : 1,
      tips: val ? val : "",
    });
    if (res.code === 0) {
      this.$Message.success(res.msg);
      this.init();
      if (val) {
        const $anomalyModal: any = this.$refs.anomalyModal;
        $anomalyModal.modal = false;
      }
    }
  }
}
